const PopUpObjects = [
  {
    id: 0,
    title: "Prototyping - Services",
    text: "How might we rapidly prototype a user's experience of a service without direct access to them?",
    text2: "Chart the path of the user and what would be seen and experienced at each stage using sticky notes."
  },
  {
    id: 1,
    title: "Prototyping - Processes",
    text: "How might we improve specific or existing processes such as shopping at a grocery store?",
    text2: "Personas, journey, and empathy maps help us center the user, whether internal or external. Whiteboards highly encouraged."
  },
  {
    id: 2,
    title: "Design Thinking - Facilitation",
    text: "How might we make junior employees comfortable sharing honest, unhindered ideas around the C-suite?",
    text2: "Sessions in a corporate setting involve leveling the playing field amongst everyone present, no matter their title, and encouraging the sharing of ideas through activities so that one may trigger another."
  },
  {
    id: 3,
    title: "Branding - Building",
    text: "How might we make a brand memorable and also encourage loyalty?",
    text2: "Corporate brand building means understanding the users in the target market from the early to the late adopters. Loyalty is earned by human centered design and the incorporation of feedback."
  },
  {
    id: 4,
    title: "Product Development - Process",
    text: "How might we identify gaps in the market that can be filled by a new product? How do you rapidly prototype such a product?",
    text2: "Start with a problem to be solved, and design a solution that brings moments of delight to the user. Prototype using cardboard, or find a maker space."
  },
  {
    id: 5,
    title: "Product Development - Optimization",
    text: "What's the Minimum Viable Product (MVP)? How can it be incrementally improved for performance or effectiveness?",
    text2: "User feedback comes into play to streamline and refine. Ideate again with new information."
  }]

export default PopUpObjects;